export default __webpack_public_path__ + "static/media/TOken_NFTFeed.2f811215.mp4";